var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',{staticClass:"my-6"},[_c('v-row',[_c('v-col',[(_vm.$store.getters.user)?_c('span',{staticClass:"text-h4"},[_vm._v(" Hola, "+_vm._s(_vm.$store.getters.user.name)+" ")]):_vm._e()])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }